import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:2000', // Backend running on port 2000
    headers: {
      'Content-Type': 'application/json',
    },
});

// Helper function to get the token
const getAuthHeaders = () => {
  const token = localStorage.getItem('token'); 
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const userAPI = {
  getAllUsers: () => api.get('/api/get_users', {
    headers: getAuthHeaders()
  }),

  createUser: (userData) => api.post('/api/add_user', userData, {
    headers: getAuthHeaders()
  }),

  updateUser: (userId, userData) => api.put(`/api/update_user/${userId}`, userData, {
    headers: getAuthHeaders()
  }),

  deleteUser: (userId) => api.delete(`/api/delete_user/${userId}`, {
    headers: getAuthHeaders()
  }),

  activateUser: (userId) => api.put(`/api/active_status/${userId}`, {}, {
    headers: getAuthHeaders()
  }),

  login: ({ email, password, isAdminLogin }) => api.post('/api/auth/login', { email, password, isAdminLogin }),

  register: ({ username, email, password }) => api.post('/api/auth/register', { username, email, password }),

  logoutUser: () => api.post('/api/auth/logout', {}, {
    headers: getAuthHeaders()
  }),

  requestPasswordReset: (email) => api.post('/api/auth/forgot-password', { email }),

  verifyOtp: (email, otp) => api.post('/api/auth/verify-otp', { email, otp }),

  resetPassword: (email, newPassword) => api.post('/api/auth/reset-password', { email, new_password: newPassword }),

  keyword: (payload) => api.post('/api/keyword', payload, {
    headers: getAuthHeaders()
  }),
};

export default userAPI;
